import { Component, Input } from "@angular/core";

@Component({
  selector: "artbycoloring-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent {
  title = "mathart";

  @Input() basementValues: any;
}
